import { useEffect, useRef, useState } from "react";
import { useAuthentication } from "../../../auth-provider/AuthProvider";
import { Status } from "../../../client/status";
import { useMenuIdFromURL } from "../../../hooks/menuIdFromURL";

export const useAddItemToMenuClient = () => {
  const menuId = useMenuIdFromURL();
  const [status, setStatus] = useState<Status>(Status.NotStarted);
  const { token } = useAuthentication();
  const mounted = useRef(true);

  useEffect(() => {
    return function cleanup() {
      mounted.current = false;
    };
  }, []);

  return {
    addItemToMenu: async (itemDetails: AddItemType) => {
      setStatus(Status.Pending);
      const response = await fetch(`/api/menu/${menuId}/add-item/`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + token,
        },
        body: JSON.stringify(itemDetails),
      });

      if (response.status == 201) {
        mounted.current && setStatus(Status.Success);
        return;
      }
      mounted.current && setStatus(Status.Error);
    },
    status: status,
  };
};

type AddItemType = {
  categoryId: number;
  itemName: string;
  price: number;
};
